const zh = {
  header: {
    tip1:
      "In order to prevent the system from accidentally shutting down the game that is being done in your virtual space, your game is interrupted by the unknown, and you need to manually follow the following steps to complete the Settings.",
  },
  content: {
    list1: {
      title:
        "When the status of multi-process management is maintained, pull down the process page of virtual master and click 'Lock' to keep the background running",
    },
    list2: {
      title1:
        "Make sure the phone has enough memory. If the native machine runs out of memory, the system will automatically clean up the process. Even locked applications may be cleaned.- Search for [App Launch Management]",
      title2:
        "It is recommended that you take the initiative to clean up redundant background applications while running in virtual space.",
    },
  },
};

export default zh;
